import React, { Component } from 'react';
import PropTypes from 'prop-types';
import SubscriptionForm from './SubscriptionForm';

class Edit extends Component {
  render() {
    const {
      isModalOpen,
      onCloseHandler,
      onSubmitHandler,
      error,
      submitting,
      subscription,
    } = this.props;

    return (
      <SubscriptionForm
        isModalOpen={isModalOpen}
        onCloseHandler={onCloseHandler}
        onSubmitHandler={onSubmitHandler}
        error={error}
        submitting={submitting}
        subscription={subscription}
      />
    );
  }
}

Edit.propTypes = {
  isModalOpen: PropTypes.bool,
  onCloseHandler: PropTypes.func,
  onSubmitHandler: PropTypes.func,
  error: PropTypes.string,
  submitting: PropTypes.bool,
  subscription: PropTypes.object,
};

Edit.defaultProps = {
  isModalOpen: false,
  onCloseHandler: () => {},
  onSubmitHandler: () => {},
  error: null,
  submitting: false,
  subscription: {},
};

export default Edit;
